var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarnesNoble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#pattern0_4332_2551)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4332_2551",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4332_2551",
    transform: "scale(0.005)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4332_2551",
    width: 200,
    height: 200,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAAM1BMVEVTV1r///+pq63U1db09fVeYmS/wMFzd3l+gYPf4ODJy8uUlphpbG/q6uq0treeoaKJjI7wlgclAAAE5ElEQVR4nO2a25qjIBCEo3gWNe//tBsVoZqDzmYHM/Nt/XcahS5ouhvi40EIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYT8F3RdV3/ahn+lLVWxo+b208a8T3eoMFq6Txv0HvVQ+Myftukd2mk3fprL0krqP23V39NWm+XVuF1p9SPmZFQphvIZD0h1v+uwK7wxSlLr5GgxrdRaMb4tpAycHenHiBbzyuKUGU9rEn3Y5pJmWivKTEJe4774b9S7Y01wazQPXwmpUmH6BiGvWfEmZdlvo5/U5tGEb7m2pkT2vEWIP44mTImZUl8UUgyfFOLNyRQxWp2agW0FnnqnEDmOsS6/LiQ+a3cJEb2bWyKWGiGJqCSaqmLL5DuFiCbq7jlP0DsGVnNLJPKYuyWERCuAbEI2xsoNY8Qs7W5pcyvRhze9kbyYV8hRiqxA4OpDe0weSYQkX0jEAzMLeXS2b3CaoyABZ+9PPSsQEubF3EIedp2AjUcad1Py3K9Vqg9fSJBj8wuxNToIqa09ZmBNqVXpWAtRIYETZhdif0WvsepMwWF87ZnsIxTi58XsQux+Fr3arZwBdJwU4MfjqrdvFnKZZBdyhK1K3G2sOc1xUaXnA4RoCOhimeQWsoDBQO3sGXcdfXJ9CCEwmTI03JZHvMD6LATVRfdgO1REmBfzClmsjiDTiUOU5nQ6pBB8E7wxn5D2OTv/CbdDNRRiGIAKj1AIvAl58SMbq11oFf35Wgi+6fLiR7a6G1BQ4gP6ac9Ri6kZdUSIqwwghtxx+BBrWsvzUq8w71aRGMekEIje1i3vmJEmLAXNdLhJ8c6BhiK6g7ERN8yL96wR5a0RM6INpLcyaBPThC9EB3Hkrq2uaP7QgbWKLFCuhGAeUrcKKQa3no2ObV3Aum29Nk+FYK/ldwtRJdIohXt25/JH1dKiqkIG4WshD4gWz28WEjZRj9CdiS+tJ8w9AVnzC0IwL+obqt/OLktTrR6GH8EVDJLp7UKIHZH9xexCIA9vy/lY3n3kAed+c3EefjdEXswvxP2+FY5D+DBEoKOeVV5zUSGYF8cbhNgdeoUXmCQXMGi/s04SbrTiQmqXFytbE+cT4g5SHjD6onCHod0Eav+JuBDMi5aMQnDbbh8WT+DQrkF4LLy9cUKIvz/LLMT2kRSCW981CPulVlLIFhXuEuLC5ANmJ/nQK5ZuniXOIpJCHrKKzirEbU3xwt9qYSxdl4w8dUkLqf1lkk2IK4oUXgWHP/OZPWkhOJc5hWg4KliTxIIXEnEc4f2ZcyIEg3cmIbpbhHFrPLV1+xS0A6EraOtMCAbv7xFywR6GrEuHB4tQqxTe+dCpEDEC+YWYo3Y7fOGU4DbLOwc7FSJGIL8QU5NoeyPyuQa4uzxsPxci8mJmIdUYPh4o6XBkxYnFhRAMeZk/GIj8gyi2vy+0XLTiUO9KCDSaU4g82cLCyn3K2DbBW5Hzx6QQlxfzCRn8P3BqLCumdac/K2vHDKm6tDN2KcQFigxCKqWa8vx7C5++k4fCw6ryS0JsoHhfyDvowJG22dnnTuaFWJz+SWjxgcc6+nCyWmL4Sn1V93Nol8asDTV4LlgvyvjW8us/036Var//W3NCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCEkyR9s/yBOS1WR3gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnesNoble);
export default __webpack_public_path__ + "static/media/barnes-noble.a530828d7554a1f6f655077537299187.svg";
export { ForwardRef as ReactComponent };